import { render } from "./AccessCard.vue?vue&type=template&id=dcb52ef4"
import script from "./AccessCard.vue?vue&type=script&lang=js"
export * from "./AccessCard.vue?vue&type=script&lang=js"

import "./AccessCard.vue?vue&type=style&index=0&id=dcb52ef4&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__